export default "__VITE_ASSET__vZilSdmy__"